<template>
    <div>
        <el-form :model="from" ref="ruleForm" style="padding: 0 10%;" label-width="30%">
            <el-form-item label="组织架构" style="margin-left:-80px">
                <el-cascader v-model="ruleForm.organize_id" clearable style="margin-left:1px;width:100%" collapse-tags
                    :props="props"></el-cascader>
            </el-form-item>
            <el-form-item label="二级分类" style="margin-left:-80px">
                <el-select v-model="ruleForm.secondary_id" placeholder="请选择" style="width:100%">
                    <el-option v-for="item in typeList" :key="item.id" :label="item.secondary_category" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="使用范围" style="margin-left:-80px;">
                <el-select v-model="ruleForm.date_type" placeholder="请选择" style="width:100%">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="text-align: center;" label-width="0px">
                <el-button type="primary" @click="save"
                    style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">
                    保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        var organizeFind = async (e, spare8) => {
            var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
                identification: "1",
                organize_id: e,
                spare8: spare8,
            });
            return organizeList.data;
        };
        return {
            //组织架构数据
            organizeList: [],
            //职位数据
            postList: [],
            //年龄范围数据
            ageList: [],
            ruleForm: {
                id: '',
                organize_id: [],
                secondary_id: '',
                date_type: '',
            },
            time: '',

            //级联下拉配置
            props: {
                lazy: true,
                async lazyLoad(node, resolve) {
                    if (node.level === 0) {
                        return resolve(await organizeFind('', 'group'));
                    } else {
                        resolve(await organizeFind(node.data.id, ''));
                    }
                },
                value: "id",
                label: "organize_name",
                children: "organizeList",
                checkStrictly: true,
                multiple: false,
            },
            options: [{
                value: '1',
                label: '月度'
            }, {
                value: '2',
                label: '季度'
            }, {
                value: '3',
                label: '半年'
            }, {
                value: '4',
                label: '年度'
            }],
            typeList: [],
        }
    },
    async mounted() {
        this.ruleForm = this.$parent.$parent.ruleForm;
        var typeList = await this.$globals.AxiosGet('BudgetSecondary/getLists', {});
        this.typeList = typeList.data;

        var postList = await this.$globals.AxiosPost('organize/findHierarchy', {});
        this.postList = postList.data;

    },
    methods: {
        async save() {
            console.log(this.ruleForm);
            if (this.ruleForm.organize_id.length == 0) {
                this.$message.error('请选择组织架构！');
            } else if (this.ruleForm.secondary_id == '') {
                this.$message.error('请选择二级分类！');
            } else if (this.ruleForm.date_type == '') {
                this.$message.error('请选择使用范围！');
            } else {
                var url = '';
                var record = {
                    organize_id: this.ruleForm.organize_id,
                    secondary_id: this.ruleForm.secondary_id,
                    date_type: this.ruleForm.date_type,
                };
                if (this.ruleForm.id) {
                    record.id = this.ruleForm.id
                    url = 'BonusModifyUseType/updatePremiumTable'
                } else {
                    url = 'BonusModifyUseType/insertPremiumTable'
                }
                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.$parent.$parent.Return();
                        this.trash();
                    } else {
                        this.$message.warning(data);
                        this.trash();
                    }
                }
            }
        },
        async Update() {
            var url = 'BonusModifyDate/updatePremiumTable';
            var record = {
                id: this.ruleForm.id,
                organize_id: this.ruleForm.organize_id,
                start_date: this.ruleForm.start_date,
                end_date: this.ruleForm.end_date,
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === '-2000') {
                this.$message.error('服务器未响应！请稍后重试');
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.$message.success(data);
                    this.$parent.$parent.Return();
                    this.trash();
                } else {
                    this.$message.warning(data);
                }
            }
        },
        //清除数据
        trash() {
            this.ruleForm.id = '';
            this.ruleForm.organize_id = '';
            this.ruleForm.start_date = '';
            this.ruleForm.end_date = '';
        },
    },
}
</script>

<style></style>


// WEBPACK FOOTER //
// tab2_add.vue?35882794